module.exports = __webpack_public_path__ + "static/media/ROPEZE_BANNER_3.3e31f3ac.jpg";